
import { computed, defineComponent, ref } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'HomeMainVisual',

  setup() {
    const store = useStore()
    const currentNews = ref<number>(1)
    return {
      currentNews,
      news: computed(() => store.getters['home/getNewsTopics'])
    }
  }
})
